/**
 * @license
 * Copyright 2023 Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { COMPONENT_NAME_PREFIX } from '../constants';
const elementName = `${COMPONENT_NAME_PREFIX}stack`;
const classes = {
    DEFAULT: 'forge-stack'
};
const selectors = {
    ROOT: `.${classes.DEFAULT}`
};
const attributes = {
    INLINE: 'inline',
    WRAP: 'wrap',
    STRETCH: 'stretch',
    GAP: 'gap',
    ALIGNMENT: 'alignment'
};
const strings = {
    DEFAULT_GAP: '16'
};
export const STACK_CONSTANTS = {
    elementName,
    classes,
    attributes,
    selectors,
    strings
};
/** @deprecated Use `StackAlignment` instead. */
export var StackAlignMode;
(function (StackAlignMode) {
    StackAlignMode["Start"] = "start";
    StackAlignMode["Center"] = "center";
    StackAlignMode["End"] = "end";
})(StackAlignMode || (StackAlignMode = {}));
